module.exports = __webpack_public_path__ + "img/SideMenu.aa710b0b.svg";